import { DataTable } from '@/components/data-table/data-table';
import { DataTableSkeleton } from '@/components/data-table/data-table-skeleton';
import { DataTableViewOptions } from '@/components/data-table/data-table-view-options';
import { usePurchaseOrderDocumentsTable } from '@/features/purchase-order/hooks/use-purchase-order-documents-table';
import { cn } from '@/lib/utils';

type PurchaseOrderDocumentsTableProps = {
  purchaseOrderId: string;
};

const DOCUMENTS_TABLE_COLUMN_COUNT = 5;

export function PurchaseOrderDocumentsTable({
  purchaseOrderId,
}: PurchaseOrderDocumentsTableProps) {
  const { table, isPending } = usePurchaseOrderDocumentsTable(purchaseOrderId);
  const hasRows = table.getRowCount() > 0;

  if (isPending && !hasRows) {
    return (
      <DataTableSkeleton
        className='min-h-0'
        columnCount={DOCUMENTS_TABLE_COLUMN_COUNT}
        rowCount={8}
      />
    );
  }

  return (
    <div
      className={cn(
        'relative flex min-h-0 flex-1 flex-col',
        isPending && 'pointer-events-none',
      )}
    >
      {isPending && (
        <div className='absolute inset-0 z-20 animate-pulse rounded-md bg-muted/40' />
      )}
      <DataTable
        className={cn('min-h-0', isPending && 'opacity-60')}
        table={table}
      >
        <div
          className='flex w-full items-start justify-end gap-2 p-1'
          role='toolbar'
        >
          <DataTableViewOptions align='end' table={table} />
        </div>
      </DataTable>
    </div>
  );
}
